var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1155_131767)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88477 -0.015625C7.28582 -0.015625 7.68684 -0.015625 8.08789 -0.015625C10.8306 0.325682 12.7857 1.74756 13.9531 4.25C14.2347 4.93871 14.4124 5.64964 14.4863 6.38281C14.4863 6.78386 14.4863 7.18489 14.4863 7.58594C14.145 10.3287 12.7231 12.2837 10.2207 13.4512C9.532 13.7327 8.82106 13.9105 8.08789 13.9844C7.68684 13.9844 7.28582 13.9844 6.88477 13.9844C4.14205 13.6431 2.18696 12.2212 1.01953 9.71875C0.737981 9.03004 0.560247 8.31911 0.486328 7.58594C0.486328 7.18489 0.486328 6.78386 0.486328 6.38281C0.827636 3.6401 2.24951 1.68501 4.75195 0.517578C5.44066 0.236028 6.1516 0.0582939 6.88477 -0.015625Z",
    fill: "#FEC928"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67061 4.3646C5.19914 4.32112 5.55004 4.54901 5.72335 5.04819C5.75526 5.78191 5.40433 6.13284 4.67061 6.10093C4.16771 5.92926 3.94439 5.57836 4.00069 5.04819C4.11053 4.70596 4.33385 4.47808 4.67061 4.3646Z",
    fill: "#6E4D40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92061 4.3646C10.4491 4.32112 10.8 4.54901 10.9733 5.04819C11.0053 5.78191 10.6543 6.13284 9.92061 6.10093C9.41771 5.92926 9.19439 5.57836 9.25069 5.04819C9.36053 4.70596 9.58385 4.47808 9.92061 4.3646Z",
    fill: "#6E4D40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24042 8.73594C8.53824 8.70501 9.65479 9.13341 10.59 10.0211C10.7777 10.2929 10.7367 10.5254 10.467 10.7184C10.3596 10.7546 10.2502 10.7637 10.1389 10.7457C9.90187 10.5634 9.66491 10.3811 9.42792 10.1988C8.13251 9.45568 6.83825 9.45568 5.54511 10.1988C5.31848 10.3616 5.09973 10.5348 4.88886 10.7184C4.47143 10.8115 4.26635 10.6429 4.27362 10.2125C4.31297 10.1277 4.36312 10.0502 4.42401 9.98008C5.21753 9.23698 6.15635 8.82226 7.24042 8.73594Z",
    fill: "#6D4C40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1155_131767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad1);
export default __webpack_public_path__ + "static/media/sad 1.6416fc27c3670b188e1b1f3a2f55051b.svg";
export { ForwardRef as ReactComponent };